import type { Swiper as SwiperType } from "swiper";

export function updateCustomBullets(swiper: SwiperType): void {
  const bullets = swiper.pagination?.bullets as HTMLElement[] | undefined;
  if (!bullets) return;

  const activeIndex = swiper.realIndex;
  const lastIndex = bullets.length - 1;

  const inStartZone = activeIndex <= 2;
  const inEndZone = activeIndex >= lastIndex - 2;

  bullets.forEach((bullet, index) => {
    bullet.classList.remove("edge", "near", "is-active-custom");

    // START ZONE
    if (inStartZone) {
      if (index <= 2) {
        if (index === activeIndex) {
          bullet.classList.add("is-active-custom");
        }
      } else if (index === 3) {
        bullet.classList.add("near");
      } else {
        bullet.classList.add("edge");
      }
      return;
    }

    // END ZONE
    if (inEndZone) {
      if (index >= lastIndex - 2) {
        if (index === activeIndex) {
          bullet.classList.add("is-active-custom");
        }
      } else if (index === lastIndex - 3) {
        bullet.classList.add("near");
      } else {
        bullet.classList.add("edge");
      }
      return;
    }

    // MIDDLE ZONE
    const start = activeIndex - 2;
    const end = activeIndex + 2;

    if (index < start || index > end) {
      bullet.classList.add("edge");
      return;
    }

    if (index === activeIndex) {
      bullet.classList.add("is-active-custom");
    }

    if (index === start || index === end) {
      bullet.classList.add("near");
    }
  });
}